<template>
  <div>
    <div class="content-header text-center">
      <h2>Processing Request</h2>
    </div>
    <div class="container-fluid min-content-height">
      <stripe-checkout
        ref="checkoutRef"
        :mode="this.thisMode"
        :pk="this.stripePk"
        :line-items="lineItems"
        :success-url="successURL"
        :cancel-url="cancelURL"
        :customer-email="userEmailval"
        :session-id="sessionId"
        @loading="v => loading = v"
      />
      <div class="row">
        <div class="col-sm-12 h-100">
            <div class="container-fluid min-content-height position-relative">
              <div class="loader-container">
                  <div class="loader">
                      <i class="fas fa-spinner fa-pulse fa-10x"></i>
                  </div>
              </div>
          </div>
        </div>  
      </div>
    </div>
  </div>
</template>


<script>
import { StripeCheckout } from '@vue-stripe/vue-stripe';
import axios from 'axios';
import { useCookies } from "vue3-cookies";
import { defineComponent, onMounted, ref } from 'vue';
export default {
  name: 'PurchaseEmailCredits',
  props: {
    productTitle: '',
    productSku: '',
    productPrice: '',
    userData: [],
    stripePk: '',
    thisMode: '',
    sessionId: '',
    ProdCredits: ''
  },
  components: {
    StripeCheckout
  },
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  data () {
    this.publishableKey = this.stripePk;
    return {
      loading: false,
      sessionId: '',
      setMode: '',
      confirmHash: '',
      remaining: '',
      prospects: '',
      subscription_val: '',
      lineItems: [
        {
          price: this.productSku,
          quantity: 1,
        },
      ],
      successURL: '',
      cancelURL: window.location.protocol+'//'+window.location.hostname+'/authenticate',
      userEmailval: this.userData.email
    };
  },
  methods: {
    submit () {
      this.$refs.checkoutRef.redirectToCheckout();
      console.log('SUBMITTED to stripe... ');
    },
  },
  mounted () {
    //console.log('test new email var '+this.userEmailval);
    axios.get('/confirm_initial_login')
    .then(
      (response) => {
        this.confirmHash = response.data;
        var cookiecode = Math.ceil(Math.random()*1000000);
        this.cookies.set("appendverify", cookiecode);
        this.successURL = window.location.protocol+'//'+window.location.hostname+'/authenticate?username='+this.userData.user+'&confirm='+this.confirmHash+'&appendselect='+this.ProdCredits+'&appendverify='+cookiecode;
        //console.log('Prod sku '+this.productSku);
        //console.log('Prod mode '+this.thisMode);  
        //console.log('User Name '+this.userData.user);
        //console.log('confirm Hash '+this.confirmHash);
        //console.log('cookie code '+cookiecode); 
        //console.log('cookie value '+this.cookies.get('appendverify')); 
        //console.log('Success URL: '+this.successURL);   
        axios.get('/create_checkout_session', { params: {productkey: this.productSku, producttype: this.thisMode, successurl: this.successURL} })
          .then(
            (response) => {
              //console.log('session id general response'+JSON.stringify(response.data))
              //console.log('session id is'+response.data.sessionId);
              this.sessionId = response.data.sessionId;
              //console.log('success URL: '+this.successURL);
              //console.log('Session ID '+this.sessionId);
              this.submit();
            })
            .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error- in CREATE CHECKOUT SESSION REQUEST!", error);
            });
        // end session ID request
      }
    )
    .catch(
      (error) => {
        this.errorMessage = error.message;
        console.error("There was an error in CONFIRM INITIAL LOGIN REGUEST!", error);
    }
    ); 
  },
};
</script>